class AnimatedAccordion {
  constructor(el) {
    this.el = el
    this.summary = el.querySelector('summary')
    this.content = el.querySelector('.accordion__content')
    this.animation = null
    this.contentAnimation = null
    this.isClosing = false
    this.isExpanding = false
    this.siblings = []
    this.summary.addEventListener('click', (e) => this.onClick(e))
  }

  onClick(e) {
    e.preventDefault()
    this.el.style.overflow = 'hidden'

    if (this.isClosing || !this.el.open) {
      this.open()
    } else if (this.isExpanding || this.el.open) {
      this.shrink()
    }
  }

  getContentHeight() {
    const marginBottom = parseFloat(getComputedStyle(this.content).marginBottom)
    return this.content.offsetHeight + marginBottom
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`
    this.el.open = true
    requestAnimationFrame(() => this.expand())
  }

  expand() {
    this.isExpanding = true
    const startHeight = `${this.el.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight + this.getContentHeight()}px`

    this.siblings?.filter((s) => s !== this && (s.el.open || s.isExpanding) && !s.isClosing).forEach((s) => s.shrink())

    if (this.animation) this.animation.cancel()
    if (this.contentAnimation) this.contentAnimation.cancel()

    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease' })

    this.contentAnimation = this.content.animate(
      { opacity: [0, 1] },
      { duration: 250, delay: 80, easing: 'ease', fill: 'backwards' },
    )

    this.animation.onfinish = () => this.onFinish(true)
    this.animation.oncancel = () => (this.isExpanding = false)
  }

  shrink() {
    this.el.classList.add('is-closing')
    this.isClosing = true
    const startHeight = `${this.el.offsetHeight}px`
    const endHeight = `${this.summary.offsetHeight}px`

    if (this.animation) this.animation.cancel()
    if (this.contentAnimation) this.contentAnimation.cancel()

    this.contentAnimation = this.content.animate(
      { opacity: [1, 0] },
      { duration: 150, easing: 'ease', fill: 'forwards' },
    )

    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease' })

    this.animation.onfinish = () => this.onFinish(false)
    this.animation.oncancel = () => (this.isClosing = false)
  }

  onFinish(open) {
    this.el.classList.remove('is-closing')
    this.el.open = open
    this.animation = null
    if (this.contentAnimation) {
      this.contentAnimation.cancel()
      this.contentAnimation = null
    }
    this.isClosing = false
    this.isExpanding = false
    this.el.style.height = ''
    this.el.style.overflow = ''
  }
}

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('[data-accordion-group]').forEach((group) => {
    const instances = Array.from(group.querySelectorAll('.accordion details'))
      .filter((el) => el.querySelector('.accordion__content'))
      .map((el) => new AnimatedAccordion(el))
    instances.forEach((instance) => (instance.siblings = instances))
  })
}
